import Vue          from 'vue'
import Vuex         from 'vuex'
import auth         from './modules/auth'
import layout       from './modules/layout'
import datatable    from './modules/datatable'
import single       from './modules/single'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth, layout, datatable, single
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js